var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-addon",class:[{'badge-rounded': _vm.options.settings.rounded}, _vm.options.settings.position],style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.options.settings.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }